import React from 'react';
import usePagebuilder from '../../../../../../hooks/pagebuilder/usePagebuilder';
import { ColumnComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../../pageBuilder/TitleAndDescription';
import NestedComponent from './NestedComponent';

const ColumnUiComponent = ({ uiComponent }: UiComponentElementInterface<ColumnComponentInterface>) => {
  const { onEditClick, deleteColumnComponent, reorderNestedColumnComponent } = usePagebuilder();
  const templateEditMode = useSelector(({ common }) => common.templateEditMode);

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      {uiComponent?.columns && uiComponent?.columns > 0 ? (
        <div
          className={`wrapper w-full ${
            uiComponent.forceRowOnMobile ? 'flex @md:grid @md:grid-cols-1' : 'grid grid-cols-1'
          } grid-rows-1 gap-1 @sm:gap-2 @md:gap-3 @lg:gap-4 overflow-hidden`}
          style={{
            color: uiComponent?.styling?.textColor || '#000',
          }}>
          {Array(uiComponent.columns)
            .fill(undefined)
            .map((v, i) => {
              if (uiComponent.components.find((c) => c.sortIndex === i) || templateEditMode) {
                return (
                  <NestedComponent
                    component={uiComponent}
                    index={i}
                    onEdit={onEditClick}
                    onDelete={(c) => deleteColumnComponent(uiComponent, c)}
                    onMoveForward={() => reorderNestedColumnComponent(uiComponent, i + 1, i)}
                    onMoveBack={() => reorderNestedColumnComponent(uiComponent, i - 1, i)}
                  />
                );
              } else {
                return <div />;
              }
            })}
        </div>
      ) : (
        <EmptyComponent componentName="column" />
      )}
      <style jsx>{`
        .wrapper {
          @media (min-width: 1024px) {
            grid-template-columns: repeat(${uiComponent!.columns > 2 ? 2 : uiComponent?.columns}, minmax(0, 1fr));
          }
          @media (min-width: 1536px) {
            grid-template-columns: repeat(${uiComponent?.columns}, minmax(0, 1fr));
          }
        }
      `}</style>
    </>
  );
};

export default ColumnUiComponent;
